import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { http } from "../auth";
import { getFullUrl } from "../utils/config.js";
import { useThemeManager } from "../Hooks/ThemeManager";

/*-----Bootstrap-----*/
import { Form, Spinner } from "react-bootstrap";

/*-----Hoja de estilo-----*/
import "../styles/login.css";

/*-----Iconos-----*/
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";


const MainPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [baseURL, setBaseURL] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const navigate = useNavigate();
  // const [username, setUsername] = useState(localStorage.getItem('user') || '');
  // const [password, setPassword] = useState(localStorage.getItem('pass') || '');
  const [remember, setRemember] = useState(localStorage.getItem('remember') ? localStorage.getItem('remember') : false);
  const { themeColors } = useThemeManager();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const fetchData = () => {
    http
      .get(`/config/intranet_config_residencial/metadatos`)
      .then((response) => {
        setBaseURL(response.data?.url);
      })
      .catch((error) => {
        console.error("Error en la solicitud:", error);
      });
  };

 useEffect(() => {
    const url = getFullUrl("image/logo_app_blanco");
    setLogoUrl(url);
  }, []);

  const submit = async (data) => {
    setLoading(true);
    
    try {
      const response = await http.post(
        `${baseURL}api/auth/login`,
        {
          identity: data.user,
          password: data.password,
          access: "juridico",
        }
      );

      if (
        response?.data?.status == "success" &&
        response?.data?.access_token !== ""
      ) {
        localStorage.setItem("token", response.data.access_token);
        navigate("/home");
        setLoading(false)
      }
    } catch (error) {
      if (error?.response?.data?.message == "Invalid password") {
        toast.error("Contraseña inválida");
      } else if (error?.response?.data?.message == "User not found") {
        toast.error("Disculpe, ese usuario no se encuentra registrado.");
      } else {
        toast.error("Ha ocurrido un error al iniciar sesión.");
      }
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchData();
  }, [])

  useEffect(() => {
    if(remember) {
      const name = localStorage.getItem('user');
      const pass = localStorage.getItem('password');

      if(name && pass){
        setValue("user", name);
        setValue("password", pass);        
      }

      localStorage.setItem("user", watch("user"));
      localStorage.setItem("password", watch("password"));
      localStorage.setItem("remember", remember);
    } else {
      localStorage.removeItem('remember');
      localStorage.removeItem('user');
      localStorage.removeItem('password');      
    }

  }, [remember])

  return (
    <div className="containerBody">
      <div className="loginContainer loginIn">
        <div className="container">
          <div className="logoContainer">
            <img src={logoUrl} alt="Logo 360" />
          </div>
          <div className="info">
            <span className="titulo">Empresas</span>
            <span>
              ¿No tienes cuenta?{" "}
              <Link to="/registrar" className="links">
                Registrate aquí
              </Link>
            </span>
          </div>
          <form className="formulario" onSubmit={handleSubmit(submit)}>
            <div className="formGroup">
              <input
                className="formInput"
                {...register("user", {
                  required: "¡Este campo es requerido!"
                })}
                placeholder=" "
              />
              <label className="formLabel">Nombre de usuario</label>
              {errors.user && <p className="errors">{errors.user.message}</p>}
            </div>
            <div className="formGroup">
              <input
                className="formInput"
                type={showPassword ? "text" : "password"}
                {...register("password", {
                  required: "*¡Este campo es requerido!"
                })}
                placeholder=" "
              />
              <label className="formLabel">Contraseña</label>
              {errors.password && <p className="errors">{errors.password.message}</p>}
              <div
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? (
                  <FaEye className="iconEye" />
                ) : (
                  <FaEyeSlash className="iconEye2" />
                )}
              </div>
            </div>
            <div className="formGroup">
              <label className="checkbox">
                <Form.Check
                  className="check"
                  type="checkbox"
                  {...register("recordar")}
                  checked={remember}
                  onChange={e => setRemember(e.target.checked)}
                  /* tyle={{ border: `1px solid ${themeColors.primary}` }} */
                />{" "}
                Recordar mi contraseña
              </label>
            </div>
            <button type="submit" className="buttonSubmit" style={{ background: themeColors?.primary ?? '#007bff' }}  disabled={loading}>
              {loading ?
                <><div className="spinner"></div>{/* <span className="spinnerText">Cargando</span> */} </> :
                <span>Iniciar Sesión</span>
              }
            </button>
          </form>
          <span className="clav">
            <Link className="links" to="/recuperar">
              ¿Olvidaste tu contraseña?
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default MainPage;
